import axios from 'axios';
import { JSErrorLog } from './JSErrorLog';
import { BaseLog } from './BaseLog';

export function logReactError(error, info, boundary_description, level?) {
    clientLog(
        JSErrorLog({
            message: `${error.name} ${error.message}`,
            stacktrace: error.stack,
            component_stack: info.componentStack,
            boundary_description: boundary_description,
            level: level
        })
    );
}

export function clientLog(log: ReturnType<typeof BaseLog>) {
    let logArray = Array.isArray(log) ? log : [log];
    if (!logArray.filter(Boolean).length) {
        return;
    }
    return axios.post('/api/client-log', logArray);
}

export function registerGlobalErrorHadler() {
    window.onerror = (message, url, lineno, colno, error) => {
        if (typeof message !== 'string') {
            message = message.type;
        }

        clientLog(
            JSErrorLog({
                message,
                stacktrace: error?.stack ?? ''
            })
        );
    };
}
